const smartZone = '/smart-zone';

export const routes = {
  base: smartZone,
  unauthorized: '/403',
  notFound: '/not-found',
  hub: `${smartZone}/hub`,
  instruction: `${smartZone}/instruction`,
  prompt: `${smartZone}/prompt`,
  chatbot: `${smartZone}/chatbot`,
  intro: (entityId: string) => `${smartZone}/intro/${entityId}`,
  introPath: `${smartZone}/intro/:entity_id`,
  designPreview: (entityId: string) => `${smartZone}/entity/${entityId}/design-preview`,
  designPreviewPath: `${smartZone}/entity/:entity_id/design-preview`,
  entitySourceMaterial: (entityId: string) => `${smartZone}/entity/${entityId}/source-material`,
  entitySourceMaterialPath: `${smartZone}/entity/:entity_id/source-material`,
  entityDocument: (entityId: string) => `${smartZone}/entity/${entityId}/document`,
  entityDocumentPath: `${smartZone}/entity/:entity_id/document`,
  entityFeature: (entityId: string) => `${smartZone}/entity/${entityId}/feature`,
  entityFeaturePath: `${smartZone}/entity/:entity_id/feature`,
  entityReview: (entityId: string) => `${smartZone}/entity/${entityId}/review`,
  entityReviewPath: `${smartZone}/entity/:entity_id/review`,
  entitySlider: (entityId: string) => `${smartZone}/entity/${entityId}/sidebar`,
  entitySliderPath: `${smartZone}/entity/:entity_id/sidebar`,
  agent: `${smartZone}/agent`,
};

export function toRelativePath(absolutePath: string, baseName = '/smart-zone'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    // Remove the baseName portion
    relative = absolutePath.substring(baseName.length);
  }

  // If there's a leading '/', strip it out so the returned path doesn't start with '/'
  return relative.startsWith('/') ? relative.substring(1) : relative;
}
